export class ErrorService {
  static client = window.Sentry ? window.Sentry : undefined;

  static setUser(email: string | undefined) {
    ErrorService.client?.onLoad(() => {
      ErrorService.client?.setUser({ email: email });
    });
  }

  static report(error: unknown) {
    try {
      ErrorService.client?.captureException(error);
    } catch (e) {
      console.log("Error while reporting error", e);
    }
  }
}
